import React from "react";
import { useNavigate } from "react-router-dom";

const PaymentDetails = () => {
  const navigate = useNavigate();

  const qrCodeUrl = "/scan.jpg"; // QR Image
  const permissionPdfUrl = "/permission.pdf"; // PDF from public folder

  return (
    <section
      aria-label="Payment Details Section"
      style={{
        maxWidth: "900px",
        margin: "50px auto",
        padding: "40px 20px",
        backgroundColor: "#fff",
        borderRadius: "16px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#333",
        display: "flex",
        flexDirection: "column",
        gap: "40px",
      }}
    >
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        style={styles.backBtn}
      >
        ← Back
      </button>

      {/* Payment Content */}
      <div style={styles.flexWrap}>
        {/* QR Section */}
        <div style={styles.qrBox}>
          <div style={styles.qrImgBox}>
            <img
              src={qrCodeUrl}
              alt="Scan QR code to pay"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
          <p style={styles.qrText}>
            Scan the QR code to make payment easily via UPI
          </p>
        </div>

        {/* Bank Details */}
        <div style={styles.bankBox}>
          <h2 style={styles.heading}>Bank Account Details</h2>

          <table style={styles.table}>
            <tbody>
              <tr><th style={styles.th}>Account Name</th><td style={styles.td}>Tamilmanamalai Charitable Trust</td></tr>
              <tr><th style={styles.th}>Bank</th><td style={styles.td}>HDFC Bank</td></tr>
              <tr><th style={styles.th}>Account No</th><td style={styles.td}>50200112993963</td></tr>
              <tr><th style={styles.th}>Account Type</th><td style={styles.td}>Current Account</td></tr>
              <tr><th style={styles.th}>IFSC</th><td style={styles.td}>HDFC0005967</td></tr>
              <tr><th style={styles.th}>Branch</th><td style={styles.td}>Jayankondam</td></tr>
              <tr><th style={styles.th}>GPay No</th><td style={styles.td}>9976227686</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* PERMISSION PDF SECTION */}
      <div style={styles.pdfSection}>
        <h2 style={styles.heading}>Income Tax Department, Government of India</h2>
        <h4 style={{
    textAlign: "justify",
    lineHeight: "1.7",
    fontWeight: "500",
    color: "#444",
    marginBottom: "20px",
  }}>Form No. 10AC is issued to charitable or religious trusts / institutions as proof of registration or provisional registration under the Income Tax Act, 1961 (sections 12AB).
It authorizes the trust to claim tax exemption and allows donors to avail tax deduction,</h4>
        <iframe
          src={permissionPdfUrl}
          title="Permission PDF"
          style={styles.pdfFrame}
        />

        <a
          href={permissionPdfUrl}
          download
          style={styles.downloadBtn}
        >
          ⬇ Download Permission PDF
        </a>
      </div>
    </section>
  );
};

/* STYLES */
const styles = {
  backBtn: {
  alignSelf: "flex-start",
  marginTop: "40px",   // ← ADD THIS (change value as you like)
  padding: "10px 20px",
  backgroundColor: "#00796b",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: "16px",
},

  flexWrap: {
    display: "flex",
    flexWrap: "wrap",
    gap: "40px",
    justifyContent: "center",
  },
  qrBox: {
    flex: "1 1 300px",
    backgroundColor: "#e0f7fa",
    padding: "25px",
    borderRadius: "12px",
    textAlign: "center",
  },
  qrImgBox: {
    width: "220px",
    height: "220px",
    margin: "0 auto",
    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
    borderRadius: "12px",
    overflow: "hidden",
  },
  qrText: {
    marginTop: "15px",
    fontStyle: "italic",
    color: "#004d40",
  },
  bankBox: {
    flex: "1 1 450px",
    backgroundColor: "#fafafa",
    padding: "25px",
    borderRadius: "12px",
  },
  heading: {
    textAlign: "center",
    color: "#00796b",
    marginBottom: "20px",
    fontSize: "26px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    textAlign: "left",
    padding: "12px",
    backgroundColor: "#e0f2f1",
    color: "#004d40",
    width: "45%",
  },
  td: {
    padding: "12px",
    borderBottom: "1px solid #ddd",
  },
  pdfSection: {
    marginTop: "20px",
    padding: "25px",
    borderRadius: "14px",
    backgroundColor: "#f9f9f9",
    boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
  },
  pdfFrame: {
    width: "100%",
    height: "500px",
    border: "1px solid #ccc",
    borderRadius: "10px",
  },
  downloadBtn: {
    display: "inline-block",
    marginTop: "15px",
    padding: "12px 20px",
    backgroundColor: "#2196f3",
    color: "#fff",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: "600",
  },
};

export default PaymentDetails;
